import { z } from "zod";

/**
 * Customer resolution strategies for sales-order-draft creation steps.
 *
 * Single source of truth: step config schemas (Zod), the backend strategy
 * dispatcher, and the workflow editor renderer all reference these constants
 * so adding or removing a strategy is a one-file change.
 */
export const CUSTOMER_RESOLUTION_MODES = [
  "embeddings",
  "location_first",
  "known",
] as const;

export const customerResolutionModeSchema = z.enum(CUSTOMER_RESOLUTION_MODES);

export type CustomerResolutionMode = z.infer<
  typeof customerResolutionModeSchema
>;
